<template>
  <div class="realtive h-full w-full">
    <tableButtonGroup class="mt-10px" v-model="activeTab" :list="tabList" />
    <div class="mt-20px tab-wrap">
      <!-- 基本信息start -->
      <div v-show="activeTab === '基本信息'">
        <el-form :model="baseInfoFormData" ref="formRef" label-width="100px" disabled label-suffix=" :">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('预案编号')}`">
                <el-input
                  size="small"
                  v-model="baseInfoFormData.no"
                  disabled
                  class="w-full"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('预案名称')}`">
                <el-input size="small" v-model="baseInfoFormData.name" class="w-full" />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              v-if="baseInfoFormData.typeName !== '综合应急预案'"
            >
              <el-form-item :label="`${$t('预案类别')}`">
                <el-input size="small" v-model="baseInfoFormData.categoryName" class="w-full" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('预案类型')}`">
                <el-input size="small" v-model="baseInfoFormData.typeName" class="w-full" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('所属部门')}`">
                <el-input
                  size="small"
                  v-model="baseInfoFormData.eascOrganizationName"
                  class="w-full"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('版次')}`">
                <el-input class="mr-10px" size="small" v-model="baseInfoFormData.version" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('编制概要')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="baseInfoFormData.summary"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <categoryTitle title="版次及记录" />
        <el-table :data="versionTableList" class="mt-20px" height="200px" ref="tableRef">
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column
            :label="`${$t('版次')}`"
            prop="version"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('编制与修订概要')}`"
            prop="summary"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('创建/修订人')}`"
            prop="writeName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('创建/修订时间')}`"
            prop="creationTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column :label="`${$t('状态')}`" show-overflow-tooltip>
            <template #default="{ row: { status } }">
              {{ status ? statusList[status - 1].label : '' }}
            </template>
          </el-table-column>
          <el-table-column
            :label="`${$t('发布人')}`"
            prop="publisher"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="`${$t('发布时间')}`" prop="publishDate" show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="`${$t('实施时间')}`" prop="executeDate" show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="`${$t('操作')}`" width="50">
            <template #default="{ row }">
              <span @click="viewLastVersion(row)" class="cursor-pointer text-[#44F1FF]">{{ $t('查看') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 基本信息end -->

      <!-- 事故风险分析start -->
      <div v-show="activeTab === '事故风险分析'">
        <el-form :model="accidentFormData" label-width="100px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('事故风险')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="accidentFormData.accident"
                  style="width:100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('严重程度')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="accidentFormData.severity"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('影响范围')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="accidentFormData.reach"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 事故风险分析end -->

      <!-- 应急组织机构及职责start -->
      <div v-show="activeTab === '应急组织机构及职责'">
        <el-button
          size="mini"
          type="primary"
          :disabled="!$hasAccess('chart')"
          @click="showTreeChart"
          class="float-right"
          >应急组织架构图</el-button
        >
        <el-table :data="dutyMemberTableList" height="200px" ref="dutyTableRef">
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column
            :label="`${$t('人员名称')}`"
            prop="name"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('应急组织名称')}`"
            prop="organizationName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('组织角色')}`"
            prop="roleName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('部门')}`"
            prop="eascOrganizationName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="`${$t('岗位')}`" prop="eascPostName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            :label="`${$t('联系方式')}`"
            prop="userMobilePhoneNo"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          class="mt-10px text-center"
          background
          small
          @size-change="dutyMemberSizeChange"
          @current-change="dutyMemberSearchList"
          :current-page.sync="dutyMemberPage.pageNo"
          :pager-count="5"
          :page-size.sync="dutyMemberPage.pageSize"
          layout="total, prev, pager, next"
          :total="dutyMemberPage.pageTotal"
        ></el-pagination>
      </div>
      <!-- 应急组织机构及职责end -->

      <!-- 应急响应start -->
      <div v-show="activeTab === '应急响应'">
        <el-form :model="responseFormData" label-width="140px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急信息报告程序和内容')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="responseFormData.content"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div>
          <categoryTitle title="响应等级" />
        </div>
        <el-table :data="responseTableList" height="200px" class="mt-20px" ref="tableRef">
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column :label="`${$t('响应等级')}`" prop="gradeName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            :label="`${$t('启动条件')}`"
            prop="startingConditions"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            :label="`${$t('响应程序')}`"
            prop="responseProcedure"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <!-- 应急响应end -->

      <!-- 处置措施start -->
      <div v-show="activeTab === '处置措施'">
        <el-form :model="treatmentMeasureFormData" label-width="130px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急处置原则')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="treatmentMeasureFormData.policy"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('先期处置')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="treatmentMeasureFormData.earlier"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急处置具体要求')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="treatmentMeasureFormData.ask"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <categoryTitle title="处置措施" />
        <el-table
          stripe
          :data="treatmentMeasureTableList"
          v-loading="treatmentMeasureTableLoading"
          :highlight-current-row="true"
          height="150px"
          class="mt-20px"
          ref="tableRef"
        >
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column
            :label="`${$t('处置措施')}`"
            prop="measure"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('措施内容')}`"
            prop="content"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <!-- 处置措施end -->

      <!-- 附件start -->
      <div v-show="activeTab === '附件'">
        <el-row>
          <FileInfo :fileIdList="fileIdList" />
        </el-row>
      </div>
      <!-- 附件end -->
    </div>
    <!-- 应急组织架构图start -->
    <el-dialog
      v-dialogDrag
      append-to-body
      class="small-dialog"
      :title="`${$t('应急组织架构图')}`"
      :visible.sync="treeChartVis"
      :close-on-click-modal="false"
    >
      <TreeChart :json="tree" v-for="(tree, index) in treeData" :key="index"></TreeChart>
    </el-dialog>
    <!-- 应急组织架构图end -->
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import tableButtonGroup from '@/components/cockpit/TableButtonGroup'
import dayjs from 'dayjs'

import { PlanApi } from '@wiz-api/emergency-management'
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
const planApi = new PlanApi()
const TreeChart = () => {
  return import('./TreeChart')
}
const FileInfo = () => {
  return import('./FileInfo')
}
export default {
  name: 'SpecialPlan',
  components: { tableButtonGroup, categoryTitle, TreeChart, FileInfo },
  props: {
    planRowId: {
      type: String,
      default: '',
    },
    statusList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    planRowId: {
      handler(newVal, oldVal) {
        newVal && this.getPlanDetail(newVal)
      },
      immediate: true,
    },
  },
  data() {
    return {
      tabList: ['基本信息', '事故风险分析', '应急组织机构及职责', '应急响应', '处置措施', '附件'],
      activeTab: '基本信息',
      currentDataIndex: 0,
      formData: {
        entity: {},
      },
      wfiles: '',
      dialogTitle: '', // 标题
      baseInfoFormData: {
        no: '', // 预案编号
        name: '', // 预案名称
        categoryName: '', // 预案类别
        categoryId: '',
        typeName: '', // 预案类型
        eascOrganizationID: '', // 所属部门
        version: '', // 版次
        summary: '', // 编制概要
      }, // 基本信息表单数据
      accidentFormData: {
        accident: '', // 事故风险
        severity: '', // 严重程度
        reach: '', // 影响范围
      }, // 事故风险分析表单数据
      responseFormData: {
        content: '', // 应急信息报告程序和内容
      }, // 应急响应表单数据
      treatmentMeasureFormData: {
        policy: '', // 应急处置原则
        earlier: '', // 先期处置
        ask: '', // 应急处置具体要求
      }, // 处置措施表单数据
      saveLoading: false, // 保存按钮loading
      operateType: 'create', // 操作类型 read update create
      typeNameList: [], // 预案类型下拉框数据
      dutyMemberTableList: [], // 应急组织机构及职责列表数据
      allDutyMemberTableList: [], // 所有的应急组织机构及职责列表数据
      dutyMemberTableLoading: false, // 应急组织机构及职责列表loading
      responseTableList: [], // 应急响应列表数据
      responseTableLoading: false, // 应急响应列表loading
      treatmentMeasureTableList: [], // 处置措施列表数据
      treatmentMeasureTableLoading: false, // 处置措施列表loading
      dutyMemberPage: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      }, // 应急组织机构及职责列表分页器
      responseLevelOperateType: '', // 应急响应操作类型
      responseLevelOperateData: '', // 应急响应操作项数据
      treatmentMeasureOperateType: '', // 处置措施操作类型
      treatmentMeasureOperateData: '', // 处置措施操作项数据
      departmentList: [], // 所属部门下拉框数据
      levelList: [], // 剩余响应等级下拉框数据
      versionTableList: [], // 版次及记录列表数据
      fileList: [], // 上传附件的列表
      fileIdList: [], // 上传成功文件的文件id
      treeData: [], // 组织架构图数据
      treeChartVis: false, // 组织架构图的显隐
    }
  },
  methods: {
    /**
     * @description 应急组织机构及职责列表查询
     */
    dutyMemberSearchList() {
      this.dutyMemberTableList = this.allDutyMemberTableList.slice(
        (this.dutyMemberPage.pageNo - 1) * this.dutyMemberPage.pageSize,
        this.dutyMemberPage.pageNo * this.dutyMemberPage.pageSize
      )
    },

    /**
     * @description 应急组织机构及职责分页数改变
     */
    dutyMemberSizeChange() {
      this.dutyMemberPage.pageNo = 1
      this.dutyMemberSearchList()
    },

    /**
     * @description 获取预案信息
     * @param {String} planId 预案id
     */
    async getPlanDetail(planId) {
      const [err, res] = await planApi.getPlan({
        id: planId,
      })
      if (!err) {
        this.fileIdList = _.map(res.planFiles, 'fileUrl')
        this.baseInfoFormData = res.plan
        this.accidentFormData = res.planAccident
        this.responseFormData = res.planResponse
        this.treatmentMeasureFormData = res.planMeasure
        this.treatmentMeasureTableList = res.planMeasureRelations
        this.responseTableList = res.planResponseGrades
        this.versionTableList = res.planVersions.filter((item) => {
          return [4, 5].includes(item.status)
        })
        this.allDutyMemberTableList = res.planOrgs
        // 将数据设置成可以在人员选择中使用反选的数据
        _.forEach(this.allDutyMemberTableList, (memberItem) => {
          memberItem.id = memberItem.userId
          memberItem.keyIds = _.map(
            memberItem.eascOrganizationID.split(','),
            (organizationUnitId) => {
              return organizationUnitId + memberItem.userId
            }
          )
        })
        this.dutyMemberTableList = this.allDutyMemberTableList.slice(
          (this.dutyMemberPage.pageNo - 1) * this.dutyMemberPage.pageSize,
          this.dutyMemberPage.pageNo * this.dutyMemberPage.pageSize
        )
        this.dutyMemberPage.pageTotal = this.allDutyMemberTableList.length

        _.forEach(this.versionTableList, (versionItem) => {
          if (versionItem.publishDate) {
            versionItem.publishDate = dayjs(new Date(versionItem.publishDate)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (versionItem.executeDate) {
            versionItem.executeDate = dayjs(new Date(versionItem.executeDate)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (versionItem.creationTime) {
            versionItem.creationTime = dayjs(new Date(versionItem.creationTime)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
        })
      }
    },

    /**
     * @description 获取上传文件
     */
    async getFile(id) {
      const [err, res] = await fileApi.getFileContent(id)
      if (!err) {
        return res
      }
      return null
    },

    /**
     * @description 查看该版次预案数据
     * @param {String} planId 预案id
     */
    viewLastVersion(row) {
      if (row.version === this.baseInfoFormData.version) return
      this.getPlanDetail(row.id)
    },
    /**
     * @description 查看该条数据的应急组织架构图
     * @param {String} planId 预案id
     */
    async showTreeChart() {
      this.treeChartVis = true // visble
      const [err, res] = await planApi.getOrgStructure({
        id: this.planRowId,
      })
      if (!err) {
        this.treeData = res.items
      }
    },
  },
  async created() {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  text-align: right;
}
.tab-wrap {
  height: calc(100% - 48px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  > div {
    height: calc(100% - 56px);
  }
}
</style>
